import Intercom from '@intercom/messenger-js-sdk'
import { useQuery } from '@tanstack/react-query'
import { useCallback, useEffect } from 'react'

import { w } from '../api'
import { EXTERNAL_URLS } from '../constants/url'
import { getUserQuery } from '../queries/business/v2/user/queries'

export const useIntercomMessenger = () => {
  const { data: dataUser } = useQuery(getUserQuery)

  const setIntercom = useCallback(async () => {
    if (!dataUser?.user) {
      return
    }

    const { id, name, email } = dataUser.user
    const hmacResponse: { statusCode: number; body: string } = await w
      .url(EXTERNAL_URLS.awsApiGatewayFetchingHmac, true)
      .post({
        userId: id,
      })
      .json()

    if (!hmacResponse?.body) {
      return
    }

    if (window.location.hostname === 'pro-test.lawfully.com' || window.location.hostname === 'pro.lawfully.com') {
      Intercom({
        app_id: 'ld4dsw50',
        user_id: `${id}`,
        name,
        email,
        user_hash: hmacResponse.body,
        channel: 'pro',
      })
    }
  }, [dataUser])

  useEffect(() => {
    void setIntercom()
  }, [setIntercom])
}
